import Vue from 'vue';
import Router from 'vue-router';
import RouterView from '@/vue/views/RouterView.vue';
import RootView from '@/vue/views/RootView.vue';
import MailRequestView from '@/vue/views/MailRequestView.vue';
import MailRequestCompletedView from '@/vue/views/MailRequestCompletedView.vue';
import PasswordResetView from '@/vue/views/PasswordResetView.vue';
import PasswordResetCompletedView from '@/vue/views/PasswordResetCompletedView.vue';
import DisabledUrlView from '@/vue/views/DisabledUrlView.vue';
import ErrorView from '@/vue/views/ErrorView.vue';

Vue.use(Router);

export default new Router(
	{
		mode: 'history',
		base: process.env.BASE_URL,
		routes:
		[
			{
				path: '/',
				name: 'root',
				component: RootView,
			},
			{
				path: '/mail_request',
				name: 'mail_request',
				component: MailRequestView,
			},
			{
				path: '/mail_request_completed',
				name: 'mail_request_completed',
				component: MailRequestCompletedView,
			},
			{
				path: '/password_reset',
				name: 'password_reset',
				component: PasswordResetView,
			},
			{
				path: '/password_reset_completed',
				name: 'password_reset_completed',
				component: PasswordResetCompletedView,
			},
			{
				path: '/disabled_url',
				name: 'disabled_url',
				component: DisabledUrlView,
			},
			{
				path: '/error',
				name: 'error',
				component: ErrorView,
			},
			{
				path: '/*',
				beforeEnter: (to, from, next) => {
					next({
						name: 'root',
						query: to.query,
						replace: true,
					});
				},
			},
		],
	},
);
